<template>
  <div>
    <el-button icon="el-icon-back" type="text" title="返回" class="back" @click="backPage()"></el-button>
    <div class="tab-area">
      <el-tabs v-model="activeName" topline>
        <el-tab-pane name="first">
          <template #label>
            <div class="my-label">事件登记</div>
          </template>
          <div class="add_btn">
            <div>
              <el-button type="info" v-if="this.matchStatus == 3">比赛已结束</el-button>
              <el-button type="warning" @click="finishMatch" v-else>结束比赛</el-button>
            </div>
          </div>
          <el-table :data="tableData" style="width: 100%;margin-top:20px">
            <el-table-column label="序号" type="index" align="center" width="60"></el-table-column>
            <el-table-column label="时间（分钟）" prop="minute" align="center"></el-table-column>
            <el-table-column label="球队名" prop="teamName" align="center"></el-table-column>
            <el-table-column label="球员" prop="playerName" align="center"></el-table-column>
            <el-table-column label="事件" prop="recordType" align="center">
              <template slot-scope="scope">
                <option v-if="scope.row.recordType == 1">进球</option>
                <option v-if="scope.row.recordType == 2">助攻</option>
                <option v-if="scope.row.recordType == 4">红牌</option>
                <option v-if="scope.row.recordType == 3">黄牌</option>
                <option v-if="scope.row.recordType == 5">乌龙球</option>
                <option v-if="scope.row.recordType == 6">换上</option>
                <option v-if="scope.row.recordType == 7">换下</option>
                <option v-if="scope.row.recordType == 8">两黄变一红</option>
                <option v-if="scope.row.recordType == 9">点球大战-点球</option>
                <option v-if="scope.row.recordType == 10">点球大战-失点</option>
              </template>
            </el-table-column>
            <!-- <el-table-column label="积分" prop="score"></el-table-column> -->
            <el-table-column label="操作" prop="event" align="center">
              <template slot-scope="scope">
                <el-button type="text" @click="editCourse(scope.row)">修改</el-button>
                <el-button type="text" @click="deleteOuts(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="operate-btn-com">
            <img src="https://football-go.oss-cn-hangzhou.aliyuncs.com/pic/15-icon/60-xinzeng.png" title="新增"
              style="width: 25px; height: 25px" @click="addRecord" />
          </div>

          <el-pagination layout="total, prev, pager, next" :current-page="pageInfo.page"
            :page-size="pageInfo.pageSize" :total="pageInfo.count"
            @size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>

        </el-tab-pane>
        <el-tab-pane name="second">
          <template #label>
            <div class="my-label">比赛直播</div>
          </template>
          <div class="add_btn">
            <el-button type="primary" @click="addResource">新增</el-button>
          </div>
          <el-table :data="resourceData" style="width: 100%;margin-top:20px">
            <el-table-column label="序号" type="index" align="center"></el-table-column>
            <el-table-column label="直播类型" align="center">
              <template slot-scope="scope">
                <option v-if="scope.row.resourceType == 1">微信视频号</option>
                <option v-if="scope.row.resourceType == 2">Bilibili</option>
                <option v-if="scope.row.resourceType == 3">抖音</option>
                <option v-if="scope.row.resourceType == 4">比赛录像</option>
                <option v-if="scope.row.resourceType == 5">集锦</option>
              </template>
            </el-table-column>
            <el-table-column label="录像名称" prop="title" align="center"></el-table-column>
            <el-table-column label="地址" prop="url" align="center"></el-table-column>
            <el-table-column label="创建时间" prop="createTime" align="center"></el-table-column>
            <el-table-column label="操作" prop="event" align="center">
              <template slot-scope="scope">
                <el-button type="text" @click="editResource(scope.row)">修改</el-button>
                <el-button type="text" @click="deleteResource(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane name="third">
          <template #label>
            <div class="my-label">比赛录像</div>
          </template>
          <div class="add_btn">
            <el-button type="primary" @click="addVideo">新增</el-button>
          </div>
          <el-table :data="videoData" style="width: 100%;margin-top:20px">
            <el-table-column label="序号" type="index" align="center"></el-table-column>
            <el-table-column label="录像名称" prop="title" align="center"></el-table-column>
            <el-table-column label="录像地址" prop="url" align="center"></el-table-column>
            <el-table-column label="创建时间" prop="createTime" align="center"></el-table-column>
            <el-table-column label="操作" prop="event" align="center">
              <template slot-scope="scope">
                <el-button type="text" @click="editVideoData(scope.row)">修改</el-button>
                <el-button type="text" @click="deleteResource(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </div>
    <el-dialog :visible.sync="dialogVisibleRecord" :title="title" width="60%" @close="closeDialog">
      <el-form ref="form" :model="form" label-width="100px" class="infoForm" :rules="rules">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="时间" prop="minute">
              <el-select v-model="form.minute" placeholder="请选择时间">
                <el-option v-for="item in numList" :key="item" :label="item" :value="item">
                </el-option>
              </el-select>
              <!-- <el-input v-model="form.minute" placeholder="请输入时间"></el-input> -->
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="球队" prop="teamName">
              <el-select v-model="form.teamName" placeholder="请选择球队" @change="changeTeam">
                <el-option v-for="item in teamList" :key="item.teamId" :label="item.teamName" :value="item.teamName">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="球员" prop="playerName">
              <el-select v-model="form.playerName" placeholder="请选择球员" @change="changePlayer">
                <el-option key=" " label="" value="" disabled>
                  <span style="float: left">球衣号</span>
                  <span style="float: right; font-size: 13px">球员</span>
                </el-option>
                <el-option v-for="item in playerList" :key="item.playerId"
                  :label="`${item.playerName}(${item.playerNumber})`" :value="item.playerName">
                  <span style="float: left">{{ item.playerNumber }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">{{ item.playerName }}</span>
                </el-option>
                <!-- <el-option v-for="item in playerList" :key="item.playerId" :label="item.playerName"
                  :value="item.playerName">
                </el-option> -->
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="事件" prop="recordType">
              <el-select v-model="form.recordType" placeholder="请选择事件">
                <el-option v-for="item in event" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleRecord = false">取 消</el-button>
        <el-button type="primary" @click="saveCourse">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisibleResource" :title="ResourceTitle" width="60%" @close="closeResource">
      <el-form ref="resourceForm" :model="resourceForm" label-width="100px" class="infoForm" :rules="rules">
        <el-form-item label="直播类型" prop="resourceType">
          <el-select v-model="resourceForm.resourceType" placeholder="请选择类型">
            <el-option v-for="item in resourceType" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="上传视频" v-if="resourceForm.resourceType == 5">
          <div style="display: flex;align-items: center;">
            <el-upload class="avatar-uploader" action="placeholder" :before-upload="beforeAvatarUpload"
              :http-request="uploadVideoProcess">
              <video v-if="resourceForm.url" controls="controls" :src="resourceForm.url" style="margin-left: 0"
                :width="'200px'" :height="'240px'"> </video>
              <i v-else class="el-icon-plus avatar-uploader-icon"
                :style="{ height: height, width: width, lineHeight: lineHeight }"></i>
            </el-upload>
            <span style="margin-left: 100px;">文件大小 : {{ resourceForm.size }} MB</span>
          </div>
        </el-form-item>
        <el-form-item label="资源地址" prop="url">
          <el-input placeholder="请输入资源地址" v-model="resourceForm.url"></el-input>
        </el-form-item>
        <el-form-item label="价格" prop="price">
          <el-input placeholder="请输入价格" v-model="resourceForm.price"
            onkeyup="value=value.replace(/[^\d.]/g,'')"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleResource = false">取 消</el-button>
        <el-button type="primary" @click="saveResource">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisibleVideo" :title="videoTitle" width="60%" @close="closeVideo">
      <el-form ref="videoForm" :model="videoForm" label-width="100px" class="infoForm" :rules="rules">
        <el-form-item label="录像名称">
          <el-input v-model="videoForm.title"></el-input>
        </el-form-item>
        <el-form-item label="上传视频">
          <div style="display: flex;align-items: center;">
            <el-upload class="avatar-uploader" action="placeholder" :before-upload="beforevideoForm"
              :http-request="videoFormProcess">
              <video v-if="videoForm.url" controls="controls" :src="videoForm.url" style="margin-left: 0" :width="'200px'"
                :height="'240px'"></video>
              <i v-else class="el-icon-plus avatar-uploader-icon"
                :style="{ height: height, width: width, lineHeight: lineHeight }"></i>
            </el-upload>
            <span style="margin-left: 100px;">文件大小 : {{ videoForm.size }} MB</span>
          </div>
        </el-form-item>
        <el-form-item label="价格" prop="price">
          <el-input placeholder="请输入价格" v-model="videoForm.price" onkeyup="value=value.replace(/[^\d.]/g,'')"></el-input>
        </el-form-item>
        <el-form-item label="资源地址" prop="url">
          <el-input placeholder="请输入资源地址" v-model="videoForm.url"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleVideo = false">取 消</el-button>
        <el-button type="primary" @click="saveVideo">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      required: true,
    },
    size: {
      type: Number,
      default: 50,
    },
    height: {
      type: String,
      default: '240px',
    },
    width: {
      type: String,
      default: '200px',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      matchStatus: '',
      status: false,
      tableData: [],
      event: [],
      teamList: [
        { teamName: '', teamId: '' },
        { teamName: '', teamId: '' },
      ],
      pageInfo: {
        page: 1,
        pageSize: 10,
        count: 0,
      },
      activeName: "first",
      form: {},
      playerList: [],
      matchInfo: {},
      matchList: [],
      numList: [],
      title: "",
      ResourceTitle: "",
      videoTitle: "",
      rules: {
        minute: [{ required: true, message: '请选择时间', trigger: 'change' }],
        teamName: [{ required: true, message: '请选择球队', trigger: 'change' }],
        playerName: [{ required: true, message: '请选择球员', trigger: 'change' }],
        recordType: [{ required: true, message: '请选择事件', trigger: 'change' }],
        resourceType: [{ required: true, message: '请选择资源类型', trigger: 'change' }],
        url: [{ required: true, message: '请输入地址', trigger: 'blur' }],
      },
      resourceType: [
        {
          value: 1,
          label: "微信视频号"
        },
        {
          value: 2,
          label: "Bilibili"
        },
        {
          value: 5,
          label: "集锦"
        },
        {
          value: 3,
          label: "抖音"
        }
      ],
      resourceData: [],
      resourceForm: {},
      videoForm: {},
      videoData: [],
      publicFileUrl: "",
      videoSize: "",
      dialogVisibleRecord: false,
      dialogVisibleResource: false,
      dialogVisibleVideo: false,
      upload: ""
    }
  },
  mounted() {
    this.matchInfo.matchId = this.$route.query.matchId;
    this.matchStatus = this.$route.query.status;
    this.getMatchCourse();
    this.getMinute();
    this.getTeamList();
    this.getResource();
  },
  methods: {
    // 获取赛况列表
    async getMatchCourse() {
      const params = {
        page: this.pageInfo.page,
        pageSize: this.pageInfo.pageSize,
      };
      const { res } = await this.$http.get(`/Match/MatchScheduleRecordList/${this.matchInfo.matchId}/${this.$route.query.matchScheduleId}`, { params });
      this.tableData = res.data.list || [];
      this.pageInfo.count = res.data.total;
    },
    // 获取录像列表
    async getResource() {
     const productType=2
      const { res } = await this.$http.get(`/UserTeam/LiveResourceList/${this.$route.query.matchScheduleId}?productType=${productType}`);
      this.resourceData = res.data || [];
      this.videoData = this.resourceData.filter(item => item.resourceType == '4')
    },
    // 头部组件切换比赛，加载接口数据
    changeMatch(match) {
      this.matchInfo = match;
      this.getMatchCourse()
    },
    // 获取球队
    async getTeamList() {
      this.teamList[0].teamName = this.$route.query.homeTeamName
      this.teamList[0].teamId = this.$route.query.homeTeamId
      this.teamList[1].teamName = this.$route.query.awayTeamName
      this.teamList[1].teamId = this.$route.query.awayTeamId
    },
    // 选择球队获取球员
    changeTeam(val) {
      this.form.teamId = this.teamList.find(teamList => {
        return teamList.teamName === val;
      }).teamId;
      this.getPlayerList()
    },
    // 获取球员
    async getPlayerList() {
      const { res } = await this.$http.get(`/Match/TeamPlayerList/${this.form.teamId}`);
      this.playerList = res.data || [];
    },
    // 选择球员
    changePlayer(val) {
      this.form.playerId = this.playerList.find(playerList => {
        return playerList.playerName === val;
      }).playerId;
    },
    // 选择时间
    getMinute() {
      for (let i = 1; i <= 120; i++) {
        this.numList.push(i + "’");
      }
    },
    // 保存赛况
    saveCourse() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.form.matchScheduleId = this.$route.query.matchScheduleId
          this.form.matchId = this.matchInfo.matchId
          this.$confirm('请核实信息确定要发布该赛况吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }).then(async () => {
            const { res } = await this.$http.post('/Match/SaveScheduleRecord', this.form);
            if (res.isSuccess) {
              this.$showSuccess('发布成功');
              this.dialogVisibleRecord = false;
              this.getMatchCourse();
            }
          });
        } else {
          this.$message.error("请填写完整信息！");
          return
        }
      })
    },
    // 删除赛况
    deleteOuts(row) {
      this.$confirm('请核实信息确定删除该赛况吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        const { res } = await this.$http.post(`/Match/DeleteMatchScheduleRecord/${this.matchInfo.matchId}/${row.recordId}`);
        if (res.isSuccess) {
          this.$showSuccess('删除成功');
          this.dialogVisibleRecord = false;
          this.getMatchCourse();
        }
      });
    },
    // 分页
    handleSizeChange(val) {
      this.pageInfo.pageSize = val;
      this.getMatchCourse();
    },
    handleCurrentChange(val) {
      this.pageInfo.page = val;
      this.getMatchCourse();
    },
    // 结束比赛
    finishMatch() {
      this.$confirm('确定要结束该场比赛吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        const { res } = await this.$http.post(`/Match/FinishSchedule/${this.matchInfo.matchId}/${this.$route.query.matchScheduleId}`);
        if (res.isSuccess) {
          this.$showSuccess('比赛结束');
          this.status = true
        }
      });
    },
    // 返回上一页
    backPage() {
      this.$router.back(-1)
    },
    // 新增赛况
    
    async addRecord() {
      this.dialogVisibleRecord = true;
      this.title = "新增赛况";
      const { res } = await this.$http.get(`/Match/MatchRecordTypeList`);
        if (res.isSuccess) {
          //对象转数组
          const arrayOfProps = Object.keys(res.data).map(value => ({ value, label: res.data[value] }));
          this.event = arrayOfProps;
        }
    },
    // 修改赛况
    editCourse(row) {
      this.dialogVisibleRecord = true;
      this.title = "修改赛况";
      this.form = row;
    },
    closeDialog() {
      this.dialogVisibleRecord = false;
      this.title = '';
      this.form = {};
    },
    //新增直播资源
    addResource() {
      this.ResourceTitle = "新增资源";
      this.dialogVisibleResource = true;
    },
    //修改直播资源
    editResource(row) {
      this.dialogVisibleResource = true;
      this.ResourceTitle = "修改资源";
      this.resourceForm = row
    },
    // 保存直播资源
    saveResource() {
      this.$refs.resourceForm.validate((valid) => {
        if (valid) {
          this.resourceForm.productType = 2
          this.resourceForm.scheduleId = this.$route.query.matchScheduleId
          this.resourceForm.matchId = this.matchInfo.matchId
          this.$confirm('请核实信息确定要发布该直播资源吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }).then(async () => {
            const { res } = await this.$http.post('/UserTeam/SaveLiveResource', this.resourceForm);
            if (res.isSuccess) {
              this.$showSuccess('发布成功');
              this.dialogVisibleResource = false;
              this.getResource();
            }
          });
        } else {
          this.$message.error("请填写完整信息！");
          return
        }
      })
    },
    // 关闭弹窗
    closeResource() {
      this.dialogVisibleResource = false;
      this.ResourceTitle = '';
      this.resourceForm = {};
    },
    // 关闭弹窗
    closeVideo() {
      this.dialogVisibleVideo = false;
      this.videoTitle = '';
      this.videoForm = {};
    },
    //删除直播资源
    deleteResource(row) {
      this.$confirm('确定要删除该资源吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        const { res } = await this.$http.post(`/UserTeam/DeleteLiveResource/${row.resourceId}`);
        if (res.isSuccess) {
          this.$showSuccess('删除成功');
          this.dialogVisibleResource = false;
          this.getResource();
        }
      });
    },
    // 新增比赛录像
    addVideo() {
      this.videoTitle = "新增比赛录像"
      this.dialogVisibleVideo = true
    },
    // 修改比赛录像
    editVideoData(row) {
      this.videoTitle = "修改比赛录像"
      this.dialogVisibleVideo = true
      this.videoForm = row
    },
    // 保存比赛录像
    saveVideo() {
      this.videoForm.scheduleId = this.$route.query.matchScheduleId
      this.videoForm.matchId = this.matchInfo.matchId
      this.videoForm.productType = 2
      this.videoForm.resourceType = 4
      this.$refs.videoForm.validate((valid) => {
        if (valid) {
          this.$confirm('请核实信息确定要发布该比赛录像吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }).then(async () => {
            const { res } = await this.$http.post('/UserTeam/SaveLiveResource', this.videoForm);
            if (res.isSuccess) {
              this.$showSuccess('发布成功');
              this.dialogVisibleVideo = false;
              this.getResource();
            }
          });
        } else {
          this.$message.error("请填写完整信息！");
          return
        }
      })
    },
    // 集锦
    beforeAvatarUpload(file) {
      return new Promise((resolve, reject) => {
        const isMp4 = file.type === 'video/mp4';
        if (!isMp4) {
          this.$message.error('上传视频只能是 mp4 格式!');
          return reject(false)
        }
        else {
          this.videoSize = Math.round(parseFloat(file.size / 1024 / 1024).toFixed(2))
          this.checkCom()
          if (this.upload == true) {
            this.resourceForm.size = this.videoSize
            return resolve(true);
          } else {
            return reject(false);
          }
        }
      });
    },
    //验证配额
    async checkCom() {
      this.productType = 2
      const { res } = await this.$http.get(`/UserTeam/CheckLiveQuota/${this.$route.query.matchScheduleId}?resourceSize=${this.videoSize}&productType=${this.productType}`);
      if (res.isSuccess) {
        this.upload = true
      } else {
        this.$message.error(res.msg);
        this.upload = false
      }
    },

    //进度条
    async uploadVideoProcess(req) {
      const { res } = await this.$http.get('/Common/SignatureInfo/SignatureInfo', {
        params: { fileName: req.file.name },
      });
      if (res.isSuccess) {
        const data = res.data;
        let fd = new FormData();
        fd.append('OSSAccessKeyId', data.ossAccessKeyId);
        fd.append('policy', data.policy);
        fd.append('signature', data.signature);
        fd.append('key', data.key);
        fd.append('file', req.file);
        this.$http.post(data.uploadUrl, fd).then(() => {
          this.publicFileUrl = data.fileUrl;
          this.$set(this.resourceForm, "url", this.publicFileUrl)
        })
      }
    },
    // 录像
    beforevideoForm(file) {
      return new Promise((resolve, reject) => {
        const isMp4 = file.type === 'video/mp4';
        if (!isMp4) {
          this.$message.error('上传视频只能是 mp4 格式!');
          return reject(false)
        }
        else {
          this.videoSize = Math.round(parseFloat(file.size / 1024 / 1024).toFixed(2))
          this.checkCom()
          if (this.upload == true) {
            this.videoForm.size = this.videoSize
            return resolve(true);
          } else {
            return reject(false);
          }
        }
      });
    },

    //进度条
    async videoFormProcess(req) {
      const { res } = await this.$http.get('/Common/SignatureInfo/SignatureInfo', {
        params: { fileName: req.file.name },
      });
      if (res.isSuccess) {
        const data = res.data;
        let fd = new FormData();
        fd.append('OSSAccessKeyId', data.ossAccessKeyId);
        fd.append('policy', data.policy);
        fd.append('signature', data.signature);
        fd.append('key', data.key);
        fd.append('file', req.file);
        this.$http.post(data.uploadUrl, fd).then(() => {
          this.publicFileUrl = data.fileUrl;
          this.$set(this.videoForm, "url", this.publicFileUrl)
        })
      }
    },
  },
  computed: {
    lineHeight() {
      return this.height;
    },
  },

}
</script>
<style lang="scss" scoped>
.back {
  margin-top: 10px;
  font-size: 18px;
}

/deep/.el-input--small .el-input__inner {
  color: #e9e9e9;
}

.league-match {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin-top: 10px;
  background: linear-gradient(#7ECB2B, #4ebbd6);
  padding: 20px;
  border-radius: 20px;

  .leagueImage {
    width: 65px;
    height: 65px;
  }

  .leagueInfo {
    display: flex;
    align-items: center;
  }

  .teamInfo {
    display: flex;
    flex-direction: column;
    margin-left: 15px;
  }

  .lengueName {
    font-size: 23px;
  }

  .application {
    margin-top: 10px;
    font-size: 13px;
    display: flex;
    align-items: center;
  }

  .teamNum {
    color: #2e10db;
  }

  .feeType {
    margin-left: 20px;
    color: rgb(224, 205, 120);
  }

}

.tab-area {
  margin-top: 10px;
}

.notOpen {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}

.add_btn {
  display: flex;
  justify-content: flex-end;
}

.operate-btn-com {
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding: 15px;
  border-bottom: 1px solid #333;
  background-color: #fff;

  img {
    cursor: pointer;
  }
}


.avatar-uploader {
  width: 200px;
  height: auto;
  line-height: 14px !important;
  border: 1px dashed #d9d9d9 !important;


  .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  text-align: center;
}
</style>
  

